<template>
  <div class="columns is-multiline">
    <div class="column is-6">
      <b-field label="Display name">
        <b-input
          v-model="formGeneral.name"
          required>
        </b-input>
      </b-field>
    </div>
  </div>
</template>

<script>

export default {
  name: 'General',
  data () {
    return {
      formGeneral: {
        name: null
      }
    }
  },

  created() {
    this.formGeneral = this.$store.getters['testType/formGeneral'];
  }
}
</script>
